import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../http.service';
import { GlobalService } from 'src/app/global.service';

declare const $: any;
declare const autosize: any;
@Component({
  selector: 'app-business-wise-bill',
  templateUrl: './business-wise-bill.component.html',
  styleUrls: ['./business-wise-bill.component.scss']
})
export class BusinessWiseBillComponent implements OnInit {
  products = [];
  sessions = [];
  sales = [];
  tray_config = {};
  date = new Date().toISOString();
  is_sales_data_available = false;
  default_date = new Date().toISOString();
  product_ids = [];

  constructor(private http: HttpService, private global: GlobalService) {
    this.global.set_master_page_title = 'Business Wise Bill';
    this.getInitialData();
  }

  getInitialData() {
    this.getSession();
    this.getTrayConfig();
    this.getProducts();
  }

  getProducts() {
    this.http.getProductForAgentOrder().toPromise().then((data: []) => {
      console.log(data);
      this.products = data;
    }).catch((error) => {
      console.log(error);
    });
  }

  getBill(business_code, session_id, date) {
    const req_data = {
      'session_id': session_id,
      'date': date,
      'business_code': business_code
    };
    this.http.getBusinessBill(req_data).toPromise().then((data: []) => {
      console.log(data);
      this.sales = data;
      this.product_ids = Object.keys(data['sales']);
      this.is_sales_data_available = true;
    }).catch((error) => {
      console.log(error);
    });
  }

  getBusinessProductCount(product_id) {
    if (this.sales['business']['sales'].hasOwnProperty(product_id)) {
      return this.sales['business']['sales'][product_id];
    } else {
      return 0;
    }
  }

  getIcustomerProductCount(product_id) {
    if (this.sales['icustomer']['sales'].hasOwnProperty(product_id)) {
      return this.sales['icustomer']['sales'][product_id];
    } else {
      return 0;
    }
  }

  getTrayConfig() {
    this.http.getTrayConfig().toPromise().then((data) => {
      console.log(data);
      this.tray_config = data;
    }, (error) => {
      console.log(error);
    });
  }

  getProductTrayCount(product_id) {
    if (this.tray_config.hasOwnProperty(product_id)) {
      // console.log(this.tray_config[product_id][0]['product_count']);
      // console.log(typeof this.tray_config[product_id][0]['product_count']);
      // console.log(`default product_count = ${this.tray_config[product_id][0]['product_count']}`);
      const product_count = this.getBusinessProductCount(product_id) + this.getIcustomerProductCount(product_id);
      console.log(`product_count = ${product_count}`);
      if (product_count === 0) {
        return 0;
      } else  {
        // console.log(this.tray_config[product_id][0]['product_count'] / product_count);
        const tray_count: number = parseInt(String(product_count / this.tray_config[product_id][0]['product_count']), 10);
        console.log(`tray_count = ${tray_count}`);
        if (tray_count === 0) {
          return '-';
        } else {
          return tray_count;
        }
      }
    } else {
      return 0;
    }
  }
  getProductPocketCount(product_id) {
    if (this.tray_config.hasOwnProperty(product_id)) {
      // console.log(this.tray_config[product_id][0]['product_count']);
      // console.log(typeof this.tray_config[product_id][0]['product_count']);
      // console.log(`default product_count = ${this.tray_config[product_id][0]['product_count']}`);
      const product_count = this.getBusinessProductCount(product_id) + this.getIcustomerProductCount(product_id);
      // console.log(`product_count = ${product_count}`);
      if (product_count === 0) {
        return 0;
      } else  {
        // console.log(this.tray_config[product_id][0]['product_count'] / product_count);
        const tray_count: number = product_count % this.tray_config[product_id][0]['product_count'];
        console.log(`tray_count = ${tray_count}`);
        if (tray_count === 0) {
          return '-';
        } else {
          return tray_count;
        }
      }
    } else {
      return 0;
    }
  }

  getSession() {
    this.http.getSession().subscribe((data: []) => {
      console.log(data);
      this.sessions = data;
    }, (error) => {
      console.log(error);
    });
  }

  ngOnInit() {}
}
